import {ORBIT_VERSION} from '../orbit-version';
import {Check} from '@sparkware/app-utils';
import {
  B2C_APP_ID,
  IClientInfo,
  IOrbitApi,
  ISiteInfo,
  IUserInfo
} from './orbit-api.interface';
import {IServiceFactoryExtended} from './services/service-factory-extended.interface';
import {IContentAdapter, IContentAdapterCasinoGamesInfoResponse} from "@sparkware/uc-sdk-core";
import {CONTENT_ADAPTER_OBJECT_NAME} from "./b2c-adapter";
import {MarketingParams} from "../common/interfaces/marketing-params.interface";
export class OrbitApi implements IOrbitApi {
  constructor(private _services: IServiceFactoryExtended) {
  }

  get version() {

    return ORBIT_VERSION;
  }

  private get _b2cContentAdapter(): IContentAdapter {
    return window[CONTENT_ADAPTER_OBJECT_NAME] as IContentAdapter;
  }

  get userInfo(): IUserInfo {
    return {
      isAuthorized: this._services.user.isAuthorized
    };
  }
  get siteInfo(): ISiteInfo {
    return {
      brandId: this._services.sdk.getBrandID(),
      subBrandId: this._services.sdk.getSubBrandID()
    }
  }

  get clientInfo(): IClientInfo {
    return {
      fullVersion: this._services.sdk.getSkin().getVersion()
    }
  }

  /**
   * Will return an array of gameTypes which has allowWithdrawOnlyFromReal === true
   */
  async getGamesWithoutBonus() {
    return await this._b2cContentAdapter.getCasinoGamesWithoutBonus();
  }

  async deepLink(deepLinkObject: any, navigate?: any): Promise<void> {
    const deepLinkService = await this._services.deepLink;
    await deepLinkService.executeDeepLink(deepLinkObject, navigate);
  }

  bannerAdminDeepLink(action: string, id: string):any {
    const deepLinkObject = {
      action: action,
      id: id
    }

    return this.deepLink(deepLinkObject);
  }

  async getMarketingData(marketingParams: MarketingParams): Promise<any> {
    if (Check.isString(marketingParams)) {
      try {
        marketingParams = JSON.parse(marketingParams);
      } catch (err) {
        this._services.logger.error(`Failed to parse marketing params: ${marketingParams}`, err);
      }
    }

    return (await this._services.marketing).getMarketingData(marketingParams);
  }

  sendAnalytics(category?: string, action?: string, label?: string, value?: string) {
    this._services.analytics.sendAnalytics(category, action, label, value);
  }

  sendElasticInfoEvent(eventType:string, category: string, action: string, label: string, value?: string, customData: Object = null, sendToDWH: boolean = true, appID: string = B2C_APP_ID): boolean {
    return this._b2cContentAdapter.sendElasticInfoEvent({
      eventType: eventType,
      category: category,
      action: action,
      label: label,
      value: value,
      customData: customData,
      sendToDWH: sendToDWH,
      appId: appID
    });
  }

  showPwaPrompt() {
    return this._b2cContentAdapter.showPwaPrompt();
  }

  isPwaInstallable() {
    return this._b2cContentAdapter.isPwaInstallable();
  }



  async getGamesInfo(gameTypes: number[]): Promise<IContentAdapterCasinoGamesInfoResponse> {
    return await this._b2cContentAdapter.getCasinoGames(gameTypes);
  }

  getRefreshToken(): string {
    return this._services.sdk.getRefreshToken();
  }

}
